import React, { Component } from 'react'

export default class HomeAdmin extends Component {
  render() {
    return (
      <div>
        <h1>This Admin</h1>
      </div>
    )
  }
}
